<template>
  <div>
    <v-form ref="form" lazy-validation v-if="companiesConfig.logo">
      <v-card class="mb-5 mx-auto f12" width="100%" max-width="900" tile>
        <div class="grid_head pa-4">
          <div class="lh13">
            <v-img
              :src="companiesConfig.logo.png"
              max-height="70" max-width="120"
              height="100%" width="100%"
              contain position="left"
            />
            <div class="mt-2">{{ companiesConfig.company_name }}</div>
            <div>
              {{ companiesConfig.registration_address_street }}, {{ companiesConfig.registration_address_zip }}, {{ companiesConfig.registration_address_city }}
            </div>
          </div>
          <div class="grid">
            <div class="weight lh13">
              <div>{{ t['invoice_created'] }}</div>
              <div>{{ bill }}</div>
            </div>
            <div class="weight lh13">
              <div>{{ t['invoice_number'] }}</div>
              <slot name="number">
                <div>{{ data['bill_number'] || '—' }}</div>
              </slot>
            </div>
          </div>
        </div>
        <v-divider/>
        <div class="grid pa-4 lh13">
          <div>
            <div class="fw500">{{ t['billing_address'] }}</div>
            <slot name="invoicing_company">
              <div>
                {{ data.client.name + String(data.invoicing_company ? ' — ' + data.invoicing_company.name : '—') }}
              </div>
            </slot>
            <div>{{ data.client.registration_street }}</div>
            <div class="text-uppercase">
              {{ data.client.registration_zip }}
              {{ data.client.registration_city }}
            </div>
          </div>
          <div class="grid lh13 weight">
            <div>{{ t['client_number'] }}</div>
            <div>{{ data.client.id }}</div>
            <div>{{ t['term'] }}</div>
            <div>{{ LastDay }}</div>
            <div>{{ t['pay_link'] }}</div>
            <slot name="link">
              <div>{{ data['bill_link'] || '—' }}</div>
            </slot>
            <div>{{ t['pay_terms'] }}</div>
            <slot name="days">
              <div>{{ DayToPay }}</div>
            </slot>
            <div>{{ t['pay_interest'] }}</div>
            <div>{{ '8.5 %' }}</div>
            <div>{{ t['vendor_phone'] }}</div>
            <div>{{ data.client.phone || '—' }}</div>
            <div>{{ t['supplier_email'] }}</div>
            <div>{{ data.client.email  || '—' }}</div>
            <div>{{ t['alv'] }}</div>
            <div>{{ companiesConfig.vat || '—' }}</div>
          </div>
        </div>
        <div class="px-4">
          <StatisticProjectReportsBlankMainTable
            :left="Array(
              data.project.name,
              data.project.street + ', ' + data.project.zip + ', ' + data.project.city,
              $formatDate(data.period_report.start_date) + ' - ' + $formatDate(data.period_report.end_date) +
                ' Vk ' + weeks
             )"
            :right="Array(
              data.client.name,
              (data?.project?.manager?.first_name || '—') + ' ' + (data?.project?.manager?.last_name || ''),
              data?.project?.manager?.phone || '—'
            )"
            :project-id="data?.project?.internal_project_id"
          />
          <div class="scrollHorizontal">
            <v-sheet min-width="850">
              <table class="border">
                <thead class="grid_table_header">
                <tr>
                  <th>{{ p['position'] }}</th>
                  <th>{{ p['quantity'] }}</th>
                  <th>{{ p['work'] }}</th>
                  <th>{{ t['price_discount'] }}</th>
                  <th>{{ t['alv_table'] }}</th>
                  <th>{{ t['taxfree_sum'] }}</th>
                  <th>{{ t['taxable_sum'] }}</th>
                </tr>
                </thead>
                <slot/>
              </table>
            </v-sheet>
          </div>
        </div>
        <div class="pa-4 grid lh13">
          <div/>
          <div>
            <div v-if="showTax" class="weight mb-3">
              <div>ALV</div>
              <slot name="tax">
                <div>{{ data['tax_percent'] + ' %' }}</div>
              </slot>
            </div>
            <div class="d-flex justify-space-between weight">
              <div>{{ t['total_taxfree_sum'] }}</div>
              <div>{{
                  $formatCurrency(
                    !data['bill_status'] || data['bill_status'] === 'new' ? price : data['price']
                  ) + ' EUR'
                }}
              </div>
            </div>
            <div class="d-flex justify-space-between weight">
              <div>{{ t['total_taxable_sum'] }}</div>
              <div>
                {{
                  $formatCurrency(
                    !data['bill_status'] || data['bill_status'] === 'new' ? tax : data['tax']
                  ) + ' EUR'
                }}
              </div>
            </div>
            <div class="d-flex justify-space-between weight">
              <div>{{ t['total_invoice_sum'] }}</div>
              <div>
                {{
                  $formatCurrency(
                    !data['bill_status'] || data['bill_status'] === 'new' ? total_price : data['total_price']
                  ) + ' EUR'
                }}
              </div>
            </div>
          </div>
        </div>
        <v-divider/>
        <div class="pa-4 grid_footer">
          <div>
            <div class="fw500 lh13">{{ companiesConfig.company_name }}</div>
            <div class="lh13">{{ companiesConfig.registration_address_street }}</div>
            <div class="lh13">{{ companiesConfig.registration_address_zip }}, {{ companiesConfig.registration_address_city }}</div>
          </div>
          <div>
            <div class="lh13">{{ t['y-tunnus'] }}: {{ companiesConfig.company_id }}</div>
            <div class="lh13">{{ t['alv'] }}: {{ companiesConfig.vat }}</div>
            <div class="lh13">{{ t['phone'] }}: {{ companiesConfig.phone }}</div>
            <div class="lh13">{{ t['email'] }}: {{ companiesConfig.laskut_email }}</div>
          </div>
          <div>
            <div class="lh13 fw500">BIC</div>
            <div>{{ companiesConfig.bic }}</div>
          </div>
          <div>
            <div class="lh13 fw500">IBAN</div>
            <div>{{ companiesConfig.iban }}</div>
          </div>
        </div>
      </v-card>
    </v-form>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import StatisticProjectReportsBlankMainTable
  from "components/timeControl/reports/StatisticProjectReportsBlankMainTable";

export default {
  name: "FinanceInvoiceShow",
  components: {StatisticProjectReportsBlankMainTable},
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    showTax: {
      type: Boolean,
      default: true,
    }
  },
  computed: {
    ...mapGetters(['companiesConfig']),
    ...mapGetters('commonPaymentTerms', {listPaymentTerm: 'getCommonPaymentTermGrid'}),
    t() {
      return this.localStorage.translations.pages.finance['invoice-table']
    },
    p() {
      return this.localStorage.translations.pages.finance['period-table']
    },
    bill() {
      if (this.data['bill_created_at']) {
        let result = new Date(this.data['bill_created_at'])
        return String(result.getDate()).padStart(2, '0') + '.' +
          String(result.getMonth() + 1).padStart(2, '0') + '.' +
          result.getFullYear()
      }
      return '—'
    },
    weeks() {
      if (this.data['first_week'] === this.data['last_week']) return this.data['first_week'] || '—'
      return this.data['first_week'] + '-' + this.data['last_week']
    },
    price() {
      return this.data['work_types'].concat(this.data['extra_works'])
        .reduce((sum, cur) => {
          return sum + cur.total_price
        }, 0)
    },
    total_price() {
      return this.data['work_types'].concat(this.data['extra_works'])
        .reduce((sum, cur) => {
          return sum + (cur.total_price * ((100 + cur.tax_percent) / 100))
        }, 0)
    },
    tax() {
      return this.total_price - this.price
    },
    LastDay() {
      let temp = this.data['bill_last_day_to_pay'] ? this.data['bill_last_day_to_pay'].split('-') : []
      if (temp.length) return temp[2] + '.' + temp[1] + '.' + temp[0]
      return '—'
    },
    DayToPay() {
      let temp = this.data['bill_days_to_pay'] !== null
        ? this.listPaymentTerm.filter(i => i.days == this.data['bill_days_to_pay'])
        : []
      if (temp[0]) return temp[0].days ? temp[0].description + ' ' + this.t['day_term'] : temp[0].description
      return this.data['bill_days_to_pay'] !== null ? this.data['bill_days_to_pay'] + ' ' + this.t['day_term'] : ''
    },
  },
}
</script>

<style scoped lang="scss">
:deep() .grid {
  display: grid;
  grid-template-rows: auto;
  grid-template-columns: 1.2fr 1fr;
  grid-gap: 5px;
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    grid-template-columns: 1fr;
  }

  &_head {
    @extend .grid;
    align-content: center;
    align-items: center;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      grid-template-columns: 1.2fr 1fr;
    }
  }

  &_footer {
    @extend .grid;
    grid-gap: 10px;
    justify-content: space-between;
    grid-template-columns: auto auto auto auto;
    @media #{map-get($display-breakpoints, 'sm-and-down')} {
      grid-template-columns: 1fr;
    }
  }

  &_table {
    &_header {
      background-color: #f2f2f2;
      text-align: center;
    }

    .v-input {
      height: 100% !important;
    }

    td.pa-0 {
      border: none !important;
    }
  }
}

.lh13 {
  line-height: 1.3em !important;
}

.weight {
  *:nth-child(2n + 1) {
    font-weight: 500;
  }
}

.border {
  border: 1px solid #ebebeb;
}

.scrollHorizontal {
  @media #{map-get($display-breakpoints, 'sm-and-down')} {
    overflow-x: scroll;
  }
}

table {
  width: 100%;
  border-collapse: collapse;

  .v-text-field {
    margin: 0 !important;
    padding: 0 !important;
  }

  :deep() .v-text-field input {
    padding: 0 !important;
  }

  :deep() .v-text-field .v-input__control {
    border-radius: 0 !important;
    height: 100% !important;
  }

  :deep() .v-input .v-input__slot:not(.v-textarea) fieldset {
    color: #ebebeb !important;
  }

  :deep()
  .v-text-field.v-text-field--enclosed:not(.v-text-field--rounded)
  > .v-input__control
  > .v-input__slot {
    padding: 0 4px !important;

    .v-input__append-inner {
      //margin-top: 6px !important;
    }
  }
}

th {
  font-weight: normal;
}

th, :deep() td {
  @extend .border;
  padding: 4px;
  height: 35px;

  &:nth-child(1) {
    width: 40px;
  }

  &:nth-child(2) {
    width: 60px;
  }

  &:nth-child(3) {
    width: 200px;
  }

  &:nth-child(4) {
    width: 30px;
  }

  &:nth-child(5) {
    width: 30px;
  }

  &:nth-child(6) {
    width: 30px;
  }

  &:nth-child(7) {
    width: 30px;
  }
}

:deep() .v-input .v-input__append-outer {
  //margin-top: 7px !important;
  width: 70%;
}

.gap {
  column-gap: 12px;
}
</style>
